import { LoadingButton } from "@mui/lab";
import { Box, Typography } from "@mui/material";
import { useContent } from "../../content/useContent";
import { Colors } from "../../theme/colors";
import { darkModeField, darkModePassword } from "../../theme/darkModeInput";
import FormikPassword from "../Form/FormikPassword";

const classes = {
  description: {
    lineHeight: "70px",
    fontSize: "32px",
    fontWeight: "700",
    color: Colors.white,
  },
  forgetPassword: {
    display: "flex",
    justifyContent: "flex-end",
    margin: "12px 0",
    width: "100%",
    "&:hover": {
      cursor: "pointer",
      textDecoration: "underline",
      textDecorationColor: Colors.secondary,
    },
  },
  btn: {
    height: "66px",
    width: "100%",
    fontWeight: "600",
    fontSize: "18px",
  },
};

type IProps = {
  formik: any;
  loading: boolean;
  handleShowLogin: () => void;
};

const NewPasswordForm: React.FC<IProps> = ({
  formik,
  loading,
  handleShowLogin,
}) => {
  const { login } = useContent().pages;
  return (
    <>
      <Typography
        variant="h1"
        component="h1"
        color="secondary"
        sx={classes.description}
      >
        {login.newPassword}
      </Typography>
      <FormikPassword
        label={login.password}
        color="secondary"
        formik={formik}
        sx={darkModeField}
      />
      <FormikPassword
        color="secondary"
        formik={formik}
        name="confirmPassword"
        label={login.confirmPassword}
        sx={darkModePassword}
      />

      <Box sx={classes.forgetPassword}>
        <Typography
          onClick={handleShowLogin}
          variant="body2"
          component="p"
          color="secondary"
        >
          {login.log}
        </Typography>
      </Box>

      <LoadingButton
        variant="contained"
        onClick={formik.handleSubmit}
        loading={loading}
        color="secondary"
        sx={classes.btn}
      >
        {login.send}
      </LoadingButton>
    </>
  );
};

export default NewPasswordForm;
